// 3rd party imports
import * as React from 'react';
import { LocalizedText } from '@shared-ui/localization-context';
import { useStores } from 'hooks';
import { observer } from 'mobx-react';

// ui
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkEmptyState } from 'uitk-react-empty-state';

// Utils
import { analyticsEvent } from '../util/analytics';

export const ErrorMessageCommon: React.FunctionComponent = observer(() => {
  const { analytics, pzStore, userAuth } = useStores();

  React.useEffect(() => {
    if (pzStore?.pzPublisher?.network_status) {
      analyticsEvent(analytics, userAuth, pzStore, 'affhub.error.common.presented', 'Affhub Error Common Presented');
    }
  }, [userAuth?.currentUserDetails, pzStore?.pzPublisher]);

  return (
    <UitkEmptyState fullscreen={true}>
      <UitkSpacing margin={{ blockend: 'three' }}>
        <UitkIcon name="sentiment_2" size={UitkIconSize.XLARGE} />
      </UitkSpacing>
      <UitkHeading size={3} tag="h2">
        <LocalizedText message="error.common.heading" />
      </UitkHeading>
      <UitkSpacing margin="four">
        <UitkText size={300} theme="default">
          <LocalizedText message="error.common.body.text" />
        </UitkText>
      </UitkSpacing>
    </UitkEmptyState>
  );
});
